module.exports = "/pages/business/foodslabo/charm_image_5.jpg";